import { MutationTree } from "vuex";
import { RenderPostStatistic, RenderState } from "@/services/render/types";

export const mutations: MutationTree<RenderState> = {
    setRenderPostStatistic(state, data: RenderPostStatistic) {
        const postStatus = state.postStatistics.find(x => x.postId === data.postId);
        if (!postStatus) {
            data.count = 1;
            state.postStatistics.push(data);
            return;
        }

        postStatus.duration += data.duration;
        postStatus.count += 1;
    },
    clearRenderStatistics(state) {
        state.postStatistics = [];
    },
    setCurrentSolutionTimezoneId(state, solutionTimezoneId: string) {
        state.currentSolutionTimezoneId = solutionTimezoneId;
    },
    setAllowedOrigins(state, allowedOrigins: Array<string>) {
        state.allowedOrigins = allowedOrigins;
    }
};
